import { Link, useLocation } from "react-router"

import { cn } from "@f2e/ui/lib/utils"
import { buttonVariants } from "@f2e/ui/components/base"

export interface SidebarNavItem {
  href: string
  title: string
  icon?: React.ElementType
  children?: SidebarNavItem[]
}

interface SidebarNavProps extends React.HTMLAttributes<HTMLElement> {
  items: SidebarNavItem[]
}

const SidebarNav = ({ className, items, ...props }: SidebarNavProps) => {
  const location = useLocation()

  return (
    <nav
      className={cn("flex flex-col space-x-0 space-y-2", className)}
      {...props}
    >
      {items.map((item, itemIdx) => (
        <div key={itemIdx}>
          {item.children ? (
            <>
              <div className="mb-2 flex items-center gap-2 font-medium text-muted-foreground">
                {item.icon && <item.icon className="h-4 w-4" />}
                {item.title}
              </div>
              {item.children.map((child, childIdx) => (
                <div key={childIdx} className="pl-4 py-0.5">
                  <LinkItem item={child} pathname={location.pathname} />
                </div>
              ))}
            </>
          ) : (
            <LinkItem item={item} pathname={location.pathname} />
          )}
        </div>
      ))}
    </nav>
  )
}

const LinkItem = ({
  item,
  pathname,
  className,
}: {
  item: SidebarNavItem
  pathname: string
  className?: string
}) => {
  return (
    <Link
      key={item.href}
      to={item.href}
      className={cn(
        buttonVariants({ variant: "ghost" }),
        pathname === item.href
          ? "bg-muted hover:bg-muted"
          : "hover:bg-transparent",
        "justify-start text-base p-2 w-full",
        className
      )}
    >
      {item.icon && <item.icon />}
      {item.title}
    </Link>
  )
}

export { SidebarNav }
export default SidebarNav
